module.exports = __webpack_public_path__ + "static/media/a49.40bb9423.jpg";